export const classes = {
  amount: {
    opacity: 0.2,
  },
};
